import { AUTH_STEP_TYPE, useAuthNavigation } from '@jusbrasil-web/shared-auth-flows'
import { useCallback } from 'react'

import type { AuthPageEventData } from '../../utils/event-data'
import { GoogleSignIn } from '../google-sign-in'

export interface GoogleStepProps {
  email: string
  eventData: AuthPageEventData
  nextUrl?: string
  onCloseClick?: () => void
}

export function GoogleStep({ email, eventData, nextUrl, onCloseClick }: GoogleStepProps) {
  const navigate = useAuthNavigation()

  const handleUseAnotherAccount = useCallback(() => {
    navigate({ type: AUTH_STEP_TYPE.EMAIL })
  }, [navigate])

  return (
    <GoogleSignIn
      eventData={eventData}
      email={email}
      nextUrl={nextUrl}
      onUseAnotherAccount={handleUseAnotherAccount}
      onCloseClick={onCloseClick}
    />
  )
}
